// mixed nuts dont draw nutsbn so we add them manually
export const kosovoBnFeatures = {
    2021: {
        3035: {
            '03M': {
                type: 'Topology',
                arcs: [
                    [
                        [3061, 1303],
                        [-152, -59],
                        [-32, -66],
                        [-65, 72],
                        [-96, 7],
                        [-16, 59],
                        [-64, 19],
                        [-56, -39],
                        [-120, 39],
                        [-184, -19],
                        [-16, 26],
                        [32, 52],
                        [-16, 72],
                        [24, 40],
                        [8, 183],
                    ],
                    [
                        [2885, 0],
                        [-8, 46],
                        [-65, 85],
                        [-40, -7],
                        [-40, 40],
                        [0, 111],
                        [80, 13],
                        [25, 46],
                        [72, 13],
                        [40, 98],
                        [-56, 118],
                        [144, 196],
                        [-24, 79],
                        [88, 59],
                        [-24, 98],
                        [-8, 20],
                        [24, 39],
                        [8, 52],
                        [48, 72],
                        [-88, 125],
                    ],
                    [
                        [825, 2638],
                        [-112, -98],
                        [-72, -7],
                        [-88, -118],
                        [-176, -39],
                        [56, -91],
                        [88, -33],
                        [24, -53],
                        [56, -39],
                        [24, -91],
                        [-56, -46],
                        [24, -105],
                        [-56, -92],
                        [-104, 0],
                        [-48, -104],
                        [-16, -40],
                        [-57, 7],
                        [-40, -53],
                        [-16, -78],
                        [113, -118],
                        [-97, -65],
                        [-88, -99],
                        [-80, 20],
                        [-80, -39],
                        [-24, -13],
                    ],
                    [
                        [1098, 2304],
                        [-193, 66],
                        [24, 39],
                        [-16, 39],
                        [65, 13],
                        [0, 33],
                        [-65, 79],
                        [-88, 65],
                    ],
                    [
                        [2308, 1689],
                        [-153, -20],
                        [-64, 59],
                        [-40, 7],
                        [-96, -27],
                        [-104, 138],
                        [-8, 92],
                        [-32, 78],
                        [-64, 26],
                        [-32, -59],
                        [-24, 0],
                        [-56, 86],
                        [-40, 137],
                        [-25, 65],
                        [-56, 0],
                        [-56, 46],
                        [-64, -72],
                        [-120, 53],
                        [-88, -40],
                        [-88, 46],
                    ],
                ],
                transform: { scale: [37.761044752777565, 38.54734205626113], translate: [5167020.037451873, 2202278.5103255166] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: 1000004, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: 1000005, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: 1000001, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: 1000002, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: 1000003, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                        ],
                    },
                },
            },
            '10M': {
                type: 'Topology',
                arcs: [
                    [
                        [962, 0],
                        [-29, 75],
                        [48, 131],
                        [21, 35],
                        [11, 38],
                        [32, 117],
                        [-24, 44],
                    ],
                    [
                        [1021, 440],
                        [-64, -29],
                        [-70, 36],
                        [-120, 2],
                        [3, 121],
                    ],
                    [
                        [770, 570],
                        [-126, 16],
                        [-40, 91],
                        [-45, 4],
                        [-51, 93],
                        [-142, 4],
                    ],
                    [
                        [275, 891],
                        [-131, -99],
                        [30, -36],
                        [24, -31],
                        [-6, -86],
                        [-98, -86],
                        [13, -64],
                        [-27, -38],
                        [-80, -31],
                    ],
                    [
                        [366, 778],
                        [-37, 22],
                        [-54, 91],
                    ],
                ],
                transform: { scale: [113.2099448513097, 114.12782081303801], translate: [5167020.037451873, 2202278.5103255166] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: 1000005, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: 1000004, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: 1000003, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: 1000001, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: 1000002, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                        ],
                    },
                },
            },
            '20M': {
                type: 'Topology',
                arcs: [
                    [
                        [536, 0],
                        [-24, 45],
                        [15, 30],
                        [45, 92],
                        [-1, 44],
                        [-2, 37],
                    ],
                    [
                        [569, 248],
                        [-130, 9],
                        [-10, 64],
                    ],
                    [
                        [429, 321],
                        [-64, 10],
                        [-78, 94],
                        [-83, 13],
                    ],
                    [
                        [153, 502],
                        [-73, -51],
                        [26, -84],
                        [-48, -53],
                        [-3, -52],
                        [-55, -25],
                    ],
                    [
                        [204, 438],
                        [-51, 64],
                    ],
                ],
                transform: { scale: [203.12309601494124, 202.56551463031246], translate: [5167020.037451873, 2202278.5103255166] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: 1000005, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: 1000004, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: 1000003, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: 1000001, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: 1000002, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                        ],
                    },
                },
            },
            '60M': {
                type: 'Topology',
                arcs: [
                    [
                        [310, 138],
                        [-36, -2],
                        [-40, 42],
                    ],
                    [
                        [234, 178],
                        [-123, 65],
                    ],
                    [
                        [84, 278],
                        [-84, -147],
                    ],
                    [
                        [111, 243],
                        [-27, 35],
                    ],
                    [
                        [292, 0],
                        [18, 138],
                    ],
                ],
                transform: { scale: [372.84281730215633, 364.87611898580536], translate: [5167020.037451873, 2202278.5103255166] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: 1000004, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: 1000003, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: 1000001, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: 1000002, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: 1000005, lvl: 1, eu: 'F', efta: 'F', cc: 'T', oth: 'T', co: 'F' } },
                        ],
                    },
                },
            },
        },
        4326: {
            '03M': {
                type: 'Topology',
                arcs: [
                    [
                        [1900, 1275],
                        [-30, 27],
                        [-27, -13],
                        [-34, 23],
                        [-87, 6],
                        [25, 59],
                        [1, 70],
                        [20, 34],
                        [24, 167],
                    ],
                    [
                        [1792, 1648],
                        [-116, 1],
                        [-62, 77],
                        [-89, -8],
                        [-60, 148],
                        [7, 86],
                        [-4, 15],
                        [-13, 60],
                        [-45, 28],
                        [-33, -48],
                        [-26, 4],
                        [-31, 142],
                        [-11, 53],
                        [5, 43],
                        [-19, 44],
                        [-39, 8],
                        [-40, 49],
                        [-52, -59],
                        [-93, 71],
                        [-38, -6],
                        [-16, -26],
                    ],
                    [
                        [945, 2388],
                        [-54, 27],
                        [-20, 28],
                        [-22, -3],
                        [-17, 22],
                        [-25, 1],
                        [-10, 10],
                        [4, 17],
                        [27, 14],
                        [-15, 29],
                        [1, 16],
                        [68, 1],
                        [-8, 16],
                        [-5, 30],
                        [-14, 29],
                        [-27, 42],
                        [-25, 22],
                        [-30, 41],
                    ],
                    [
                        [773, 2730],
                        [-89, -69],
                        [-64, -4],
                        [-82, -92],
                        [-133, -15],
                        [27, -93],
                        [64, -43],
                        [16, -50],
                        [38, -44],
                        [9, -75],
                        [-48, -51],
                        [5, -41],
                        [6, -50],
                        [-52, -84],
                        [-78, 14],
                        [-35, -66],
                        [-33, -61],
                        [-45, 11],
                        [-35, -42],
                        [-18, -72],
                        [33, -71],
                        [48, -55],
                    ],
                    [
                        [1017, 2330],
                        [-72, 58],
                    ],
                    [
                        [307, 1677],
                        [-36, -12],
                        [-25, -21],
                        [-26, -10],
                        [-76, -90],
                        [-17, 4],
                        [-30, 31],
                        [-52, -14],
                        [-26, -23],
                        [-19, 1],
                    ],
                    [
                        [2319, 1185],
                        [-116, -32],
                        [-39, -52],
                        [-42, 70],
                        [-68, 23],
                        [-12, 58],
                        [-43, 23],
                        [-42, -23],
                        [-57, 23],
                    ],
                    [
                        [2044, 0],
                        [-4, 43],
                        [-38, 82],
                        [-34, 9],
                        [-24, 43],
                        [13, 97],
                        [61, 4],
                        [32, 41],
                        [49, 0],
                        [37, 82],
                        [-26, 118],
                        [130, 167],
                        [-8, 73],
                        [74, 46],
                        [-2, 18],
                        [-9, 92],
                        [24, 35],
                        [7, 49],
                        [48, 52],
                        [-55, 134],
                    ],
                ],
                transform: { scale: [0.0006038339283908974, 0.00036983475567765975], translate: [20.35292839300007, 42.26281764300006] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000002, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000001, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000003, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000004, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000005, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000006, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000007, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000008, co: 'F', oth: 'F' } },
                        ],
                    },
                },
            },
            '10M': {
                type: 'Topology',
                arcs: [
                    [
                        [659, 439],
                        [-54, 17],
                        [17, 111],
                    ],
                    [
                        [622, 567],
                        [-93, 31],
                        [-25, 92],
                        [-36, 11],
                        [-29, 97],
                        [-23, 1],
                        [-63, 3],
                    ],
                    [
                        [328, 822],
                        [-33, 74],
                        [-27, 44],
                    ],
                    [
                        [268, 940],
                        [-72, -44],
                        [-38, -31],
                        [27, -86],
                        [-14, -65],
                        [-81, -78],
                        [16, -58],
                    ],
                    [
                        [353, 802],
                        [-25, 20],
                    ],
                    [
                        [106, 578],
                        [-41, -19],
                        [-65, -28],
                    ],
                    [
                        [805, 408],
                        [-54, -21],
                        [-92, 52],
                    ],
                    [
                        [709, 0],
                        [-22, 72],
                        [0, 17],
                        [40, 36],
                        [18, 67],
                        [53, 101],
                        [16, 64],
                        [-9, 51],
                    ],
                ],
                transform: { scale: [0.001740521547911524, 0.0010740945563829907], translate: [20.35292839300007, 42.26281764300006] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000002, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000003, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000004, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000005, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000006, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000007, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000001, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000008, co: 'F', oth: 'F' } },
                        ],
                    },
                },
            },
            '20M': {
                type: 'Topology',
                arcs: [
                    [
                        [380, 252],
                        [-21, 26],
                        [0, 48],
                    ],
                    [
                        [359, 326],
                        [-49, 17],
                        [-56, 107],
                        [-51, 11],
                    ],
                    [
                        [189, 472],
                        [-34, 68],
                    ],
                    [
                        [155, 540],
                        [-66, -39],
                        [18, -66],
                        [-54, -68],
                        [8, -35],
                    ],
                    [
                        [61, 332],
                        [-21, -13],
                        [-10, -12],
                        [-13, 5],
                        [-17, -7],
                    ],
                    [
                        [464, 234],
                        [-84, 18],
                    ],
                    [
                        [409, 0],
                        [-14, 46],
                        [61, 110],
                        [8, 78],
                    ],
                ],
                transform: { scale: [0.003018276831896498, 0.0018697201537037245], translate: [20.35292839300007, 42.26281764300006] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000002, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000003, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000004, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000005, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000007, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000001, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000008, co: 'F', oth: 'F' } },
                        ],
                    },
                },
            },
            '60M': {
                type: 'Topology',
                arcs: [
                    [
                        [235, 156],
                        [-13, 46],
                    ],
                    [
                        [222, 202],
                        [-96, 84],
                    ],
                    [
                        [117, 293],
                        [-21, 42],
                    ],
                    [
                        [96, 335],
                        [-58, -129],
                    ],
                    [
                        [126, 286],
                        [-9, 7],
                    ],
                    [
                        [38, 206],
                        [-38, -17],
                    ],
                    [
                        [287, 145],
                        [-52, 11],
                    ],
                    [
                        [253, 0],
                        [34, 145],
                    ],
                ],
                transform: { scale: [0.004879722822299564, 0.0030138772626866006], translate: [20.352928393000074, 42.26281764300006] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000002, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000003, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000004, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000005, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000006, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000001, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000007, co: 'F', oth: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { eu: 'F', efta: 'F', cc: 'T', lvl: 0, id: 1000008, co: 'F', oth: 'F' } },
                        ],
                    },
                },
            },
        },
    },
    2024: {
        3035: {
            '03M': {
                type: 'Topology',
                arcs: [
                    [
                        [728, 1508],
                        [-48, 12],
                        [-22, 18],
                        [-15, -5],
                        [-16, 13],
                        [-22, -4],
                        [-10, 8],
                        [0, 13],
                        [21, 13],
                        [-16, 17],
                        [0, 13],
                        [58, 9],
                        [-5, 8],
                        [-10, 22],
                        [-16, 17],
                        [-27, 25],
                        [-21, 13],
                        [-32, 26],
                    ],
                    [
                        [1912, 0],
                        [-6, 30],
                        [-42, 51],
                        [-32, 0],
                        [-21, 30],
                        [0, 69],
                        [53, 8],
                        [21, 35],
                        [43, 4],
                        [26, 60],
                        [-37, 81],
                        [96, 129],
                        [-16, 51],
                        [58, 43],
                        [0, 9],
                        [-21, 64],
                        [16, 26],
                        [5, 34],
                        [32, 43],
                        [-58, 85],
                    ],
                    [
                        [250, 942],
                        [-27, -13],
                        [-21, -17],
                        [-21, -8],
                        [-59, -73],
                        [-16, 0],
                        [-26, 17],
                        [-43, -13],
                        [-21, -21],
                        [-16, 0],
                    ],
                    [
                        [1657, 861],
                        [-27, 13],
                        [-21, -13],
                        [-32, 13],
                        [-74, -9],
                        [16, 47],
                        [-6, 47],
                        [11, 26],
                        [5, 120],
                    ],
                    [
                        [1529, 1105],
                        [-100, -17],
                        [-64, 47],
                        [-75, -17],
                        [-63, 94],
                        [-6, 60],
                        [-5, 13],
                        [-16, 38],
                        [-42, 13],
                        [-22, -38],
                        [-21, 0],
                        [-42, 94],
                        [-16, 34],
                        [0, 30],
                        [-21, 30],
                        [-32, 0],
                        [-38, 30],
                        [-42, -47],
                        [-85, 39],
                        [-32, -9],
                        [-10, -21],
                    ],
                    [
                        [547, 1726],
                        [-69, -60],
                        [-53, -13],
                        [-59, -73],
                        [-111, -25],
                        [32, -60],
                        [58, -22],
                        [16, -34],
                        [37, -26],
                        [16, -51],
                        [-37, -39],
                        [5, -30],
                        [11, -34],
                        [-37, -64],
                        [-64, 4],
                        [-26, -51],
                        [-22, -47],
                        [-42, 4],
                        [-21, -34],
                        [-11, -52],
                        [37, -47],
                        [43, -30],
                    ],
                    [
                        [797, 1478],
                        [-69, 30],
                    ],
                    [
                        [2029, 852],
                        [-96, -38],
                        [-32, -39],
                        [-42, 43],
                        [-59, 4],
                        [-16, 39],
                        [-42, 13],
                        [-32, -22],
                        [-53, 9],
                    ],
                ],
                transform: { scale: [56.97629608361119, 58.91534666536319], translate: [5167020.037451873, 2202278.5103255166] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: '1000003', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: '1000008', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: '1000006', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: '1000002', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: '1000001', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { id: '1000004', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { id: '1000005', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { id: '1000007', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                        ],
                    },
                },
            },
            '10M': {
                type: 'Topology',
                arcs: [
                    [
                        [242, 508],
                        [-33, 47],
                        [-27, 27],
                    ],
                    [
                        [637, 0],
                        [-25, 46],
                        [-2, 12],
                        [30, 29],
                        [7, 47],
                        [34, 75],
                        [7, 45],
                        [-12, 33],
                    ],
                    [
                        [83, 318],
                        [-32, -18],
                        [-51, -26],
                    ],
                    [
                        [552, 290],
                        [-46, 5],
                        [3, 78],
                    ],
                    [
                        [509, 373],
                        [-79, 8],
                        [-30, 59],
                        [-30, 3],
                        [-34, 62],
                        [-19, -1],
                        [-52, -6],
                    ],
                    [
                        [182, 582],
                        [-55, -39],
                        [-28, -25],
                        [30, -56],
                        [-5, -45],
                        [-59, -62],
                        [18, -37],
                    ],
                    [
                        [265, 498],
                        [-23, 10],
                    ],
                    [
                        [676, 287],
                        [-43, -21],
                        [-81, 24],
                    ],
                ],
                transform: { scale: [171.07449827433382, 174.72145763645509], translate: [5167020.037451873, 2202278.5103255166] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: '1000004', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: '1000008', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: '1000007', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: '1000002', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: '1000003', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { id: '1000005', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { id: '1000006', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { id: '1000001', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                        ],
                    },
                },
            },
            '20M': {
                type: 'Topology',
                arcs: [
                    [
                        [50, 191],
                        [-17, -11],
                        [-8, -10],
                        [-11, 1],
                        [-14, -6],
                    ],
                    [
                        [305, 224],
                        [-44, 6],
                        [-58, 68],
                        [-44, 2],
                    ],
                    [
                        [109, 350],
                        [-52, -36],
                        [21, -45],
                        [-38, -54],
                        [10, -24],
                    ],
                    [
                        [159, 300],
                        [-14, 6],
                    ],
                    [
                        [145, 306],
                        [-36, 44],
                    ],
                    [
                        [381, 0],
                        [-17, 31],
                        [41, 85],
                        [-1, 57],
                    ],
                    [
                        [404, 173],
                        [-74, 2],
                    ],
                    [
                        [330, 175],
                        [-20, 15],
                        [-5, 34],
                    ],
                ],
                transform: { scale: [286.13294356075795, 290.536823841191], translate: [5167020.037451873, 2202278.5103255166] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: '1000007', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: '1000003', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: '1000005', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: '1000006', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: '1000004', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { id: '1000008', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { id: '1000001', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { id: '1000002', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                        ],
                    },
                },
            },
            '60M': {
                type: 'Topology',
                arcs: [
                    [
                        [258, 111],
                        [-47, 1],
                    ],
                    [
                        [32, 123],
                        [-32, -17],
                    ],
                    [
                        [211, 112],
                        [-16, 32],
                    ],
                    [
                        [195, 144],
                        [-94, 49],
                    ],
                    [
                        [70, 225],
                        [-38, -102],
                    ],
                    [
                        [101, 193],
                        [-8, 4],
                    ],
                    [
                        [93, 197],
                        [-23, 28],
                    ],
                    [
                        [243, 0],
                        [15, 111],
                    ],
                ],
                transform: { scale: [447.98943164212585, 451.9461704196305], translate: [5167020.037451873, 2202278.5103255166] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: '1000007', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: '1000001', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: '1000002', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: '1000003', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: '1000005', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { id: '1000006', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { id: '1000004', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { id: '1000008', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                        ],
                    },
                },
            },
        },
        4326: {
            '03M': {
                type: 'Topology',
                arcs: [
                    [
                        [1543, 0],
                        [-4, 32],
                        [-28, 65],
                        [-24, 5],
                        [-19, 33],
                        [10, 70],
                        [47, 5],
                        [23, 33],
                        [38, 0],
                        [28, 59],
                        [-19, 92],
                        [94, 124],
                        [-5, 54],
                        [56, 37],
                        [0, 11],
                        [-9, 70],
                        [19, 27],
                        [4, 38],
                        [38, 38],
                        [-42, 102],
                    ],
                    [
                        [1750, 895],
                        [-85, -27],
                        [-32, -37],
                        [-29, 54],
                        [-56, 16],
                        [-5, 43],
                        [-32, 16],
                        [-33, -16],
                        [-43, 16],
                    ],
                    [
                        [1435, 960],
                        [-23, 22],
                        [-19, -11],
                        [-28, 16],
                        [-66, 5],
                        [19, 44],
                        [0, 54],
                        [14, 26],
                        [19, 125],
                    ],
                    [
                        [230, 1262],
                        [-24, -5],
                        [-23, -16],
                        [-19, -11],
                        [-56, -65],
                        [-14, 0],
                        [-24, 27],
                        [-37, -11],
                        [-19, -21],
                        [-14, 5],
                    ],
                    [
                        [1351, 1241],
                        [-84, 0],
                        [-47, 59],
                        [-71, -6],
                        [-42, 114],
                        [5, 64],
                        [-5, 11],
                        [-9, 43],
                        [-33, 22],
                        [-24, -38],
                        [-23, 6],
                        [-23, 108],
                        [-5, 37],
                        [0, 33],
                        [-14, 32],
                        [-28, 5],
                        [-29, 38],
                        [-42, -43],
                        [-70, 54],
                        [-28, -5],
                        [-10, -22],
                    ],
                    [
                        [582, 2055],
                        [-66, -49],
                        [-47, -5],
                        [-61, -70],
                        [-103, -11],
                        [19, -70],
                        [51, -32],
                        [10, -38],
                        [28, -32],
                        [9, -54],
                        [-37, -44],
                        [4, -26],
                        [5, -38],
                        [-37, -65],
                        [-61, 11],
                        [-29, -49],
                        [-23, -48],
                        [-33, 11],
                        [-28, -33],
                        [-14, -54],
                        [28, -54],
                        [33, -43],
                    ],
                    [
                        [769, 1753],
                        [-56, 48],
                    ],
                    [
                        [713, 1801],
                        [-42, 17],
                        [-14, 21],
                        [-19, 0],
                        [-9, 16],
                        [-19, 0],
                        [-10, 6],
                        [5, 16],
                        [19, 11],
                        [-9, 21],
                        [0, 11],
                        [51, 0],
                        [-5, 11],
                        [-4, 22],
                        [-10, 26],
                        [-23, 27],
                        [-19, 22],
                        [-23, 27],
                    ],
                ],
                transform: { scale: [0.0007994261320208862, 0.0004913384355349169], translate: [20.35361768088405, 42.262163108155406] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: '1000008', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: '1000007', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: '1000002', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: '1000006', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: '1000001', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { id: '1000004', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { id: '1000005', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { id: '1000003', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                        ],
                    },
                },
            },
            '10M': {
                type: 'Topology',
                arcs: [
                    [
                        [539, 0],
                        [-17, 52],
                        [0, 13],
                        [30, 27],
                        [13, 48],
                        [41, 74],
                        [13, 47],
                        [-8, 38],
                    ],
                    [
                        [611, 299],
                        [-41, -16],
                        [-69, 37],
                    ],
                    [
                        [501, 320],
                        [-41, 13],
                        [12, 81],
                    ],
                    [
                        [80, 421],
                        [-31, -12],
                        [-49, -20],
                    ],
                    [
                        [472, 414],
                        [-71, 24],
                        [-18, 66],
                        [-28, 7],
                        [-21, 72],
                        [-18, 0],
                        [-47, 2],
                    ],
                    [
                        [203, 686],
                        [-54, -32],
                        [-29, -22],
                        [21, -63],
                        [-12, -47],
                        [-60, -57],
                        [11, -44],
                    ],
                    [
                        [269, 585],
                        [-20, 16],
                    ],
                    [
                        [249, 601],
                        [-25, 53],
                        [-21, 32],
                    ],
                ],
                transform: { scale: [0.002290098349828638, 0.0014718665962452685], translate: [20.35361768088405, 42.262163108155406] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: '1000008', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: '1000001', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: '1000002', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: '1000007', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: '1000003', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { id: '1000005', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { id: '1000006', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { id: '1000004', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                        ],
                    },
                },
            },
            '20M': {
                type: 'Topology',
                arcs: [
                    [
                        [337, 0],
                        [-12, 36],
                        [51, 84],
                        [6, 62],
                    ],
                    [
                        [382, 182],
                        [-69, 13],
                    ],
                    [
                        [313, 195],
                        [-17, 20],
                        [-1, 37],
                    ],
                    [
                        [50, 256],
                        [-17, -10],
                        [-8, -8],
                        [-11, 3],
                        [-14, -5],
                    ],
                    [
                        [295, 252],
                        [-40, 13],
                        [-46, 82],
                        [-41, 9],
                    ],
                    [
                        [127, 417],
                        [-54, -30],
                        [15, -51],
                        [-44, -53],
                        [6, -27],
                    ],
                    [
                        [168, 356],
                        [-12, 10],
                    ],
                    [
                        [156, 366],
                        [-29, 51],
                    ],
                ],
                transform: { scale: [0.0036618323062750017, 0.0024213440887871805], translate: [20.35361768088405, 42.262163108155406] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: '1000008', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: '1000001', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: '1000002', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: '1000007', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: '1000003', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { id: '1000005', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { id: '1000006', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { id: '1000004', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                        ],
                    },
                },
            },
            '60M': {
                type: 'Topology',
                arcs: [
                    [
                        [220, 0],
                        [29, 116],
                    ],
                    [
                        [249, 116],
                        [-45, 8],
                    ],
                    [
                        [204, 124],
                        [-12, 37],
                    ],
                    [
                        [192, 161],
                        [-83, 66],
                    ],
                    [
                        [109, 227],
                        [-8, 6],
                    ],
                    [
                        [33, 163],
                        [-33, -12],
                    ],
                    [
                        [83, 266],
                        [-50, -103],
                    ],
                    [
                        [101, 233],
                        [-18, 33],
                    ],
                ],
                transform: { scale: [0.005617750767056427, 0.003795866485053587], translate: [20.35361768088405, 42.262163108155406] },
                objects: {
                    nutsbn_1: {
                        type: 'GeometryCollection',
                        geometries: [
                            { type: 'LineString', arcs: [0], properties: { id: '1000008', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [1], properties: { id: '1000007', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [2], properties: { id: '1000002', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [3], properties: { id: '1000003', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [4], properties: { id: '1000006', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [5], properties: { id: '1000001', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [6], properties: { id: '1000005', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                            { type: 'LineString', arcs: [7], properties: { id: '1000004', lvl: 0, eu: 'F', efta: 'F', cc: 'T', oth: 'F', co: 'F' } },
                        ],
                    },
                },
            },
        },
    },
}
